(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  function markFadeTargets() {
    var blocks = document.querySelectorAll('.template-landing .product__title, .template-landing .price, .template-landing .product__description, .template-landing product-form, .template-landing .product__media-item');
    blocks.forEach(function (el, i) {
      if (el.classList.contains('product__media-item')) {
        el.classList.add('landing-reveal-init');
      } else {
        el.setAttribute('data-landing-fade', '');
        el.style.transitionDelay = (i * 60) + 'ms';
      }
    });
  }

  function setupObserver() {
    var targets = document.querySelectorAll('.template-landing [data-landing-fade], .template-landing .product__media-item');
    if (!targets.length) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('landing-reveal-in');
          entry.target.classList.remove('landing-reveal-init');
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });

    targets.forEach(function (t) { observer.observe(t); });
  }

  function setupParallax() {
    var hero = document.querySelector('.template-landing .product__media-wrapper');
    if (!hero) return;

    var ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        var rect = hero.getBoundingClientRect();
        var viewportH = window.innerHeight || document.documentElement.clientHeight;
        var progress = 1 - Math.min(Math.max(rect.top / viewportH, 0), 1);
        var translate = progress * 14;
        hero.style.transform = 'translateY(' + (-translate) + 'px)';
        ticking = false;
      });
    }, { passive: true });
  }

  function init() {
    markFadeTargets();
    setupObserver();
    setupParallax();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
